import VerifyEmail from '../components/Verify/Email'
import VerifyPassword from '../components/Verify/Password'

export default [
  {
    path: '/client/verify/email/:token',
    name: 'verify-email',
    component: VerifyEmail,
  },
  {
    path: '/client/verify/password/:token',
    name: 'verify-password',
    component: VerifyPassword,
  },
]
